"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CNED_AdaptiveTest = void 0;
const initialization_1 = require("./initialization");
const selection_1 = require("./selection");
const stopping_1 = require("./stopping");
const initialD_1 = require("./initialD");
const irt_1 = require("./irt");
//import * as fs from 'fs'
const matricesGeneration_1 = require("./matricesGeneration");
const ATM_1 = __importDefault(require("./ATM"));
var tf = require("@tensorflow/tfjs-core");
class CNED_AdaptiveTest extends ATM_1.default {
    /**
     * Class to simulate a whole adaptive test for one student
     * @param params : config object (same as in the BM)
     * @param history : histroy of the BM if we want to exploit it (in case the test is launched in the middle or
     * at the end of a module)
     * @param discriminations : discriminations of all items in the test bank
     * @param difficulties : difficulties of all items in the test bank
     */
    constructor(config, difficulties, history = undefined, discriminations, kFirst = 4) {
        super(config);
        if (!discriminations) {
            this.discriminations_no_anc = (0, matricesGeneration_1.generateFakeDiscriminationsPrerequisite)(this.params, this.parametricGraph);
        }
        else {
            this.discriminations_no_anc = discriminations;
        }
        if (!difficulties) {
            this.difficulties = (0, matricesGeneration_1.generateDifficultiesCNED)(this.params);
        }
        if (difficulties) {
            this.difficulties = difficulties;
        }
        this.numberOfKcs = Object.values(this.discriminations_no_anc)[0].length;
        this.numberOfItems = Object.keys(this.discriminations_no_anc).length;
        this.initializer = new initialization_1.FixedPointInitializer(0, this.numberOfKcs);
        this.selector = new selection_1.MaxInfoDetSelectorCNED(this.numberOfKcs);
        this.thetaEstimation = this.initializer.initialize();
        this.InformationMatrix = tf.tensor(new Array(this.numberOfKcs).fill(0));
        this.IdKFirst = this.sampleKfirst();
    }
    /**
       * Vérifie si le test doit s'arrêter
       * @returns true si le test doit s'arrêter
       */
    isTestFinished() {
        return this.stopper.stop(this.actSequence["act"], this.estimator, this.difficulties, this.discriminations_no_anc, this.actSequence, this.thetaEstimation);
    }
    /**
    * select next activity
    * @returns moduleId, objectiveId, activityId
    */
    nextActivity() {
        let actID = this.sample();
        //let actID = get_act_id(this.exercises_ontology, exId);
        let objID = this.ontology.get_objectiveID_of_activity(actID);
        let output = {
            "moduleId": this.main_act,
            "objectiveId": objID,
            "activityId": actID,
            "isAdaptiveTest": true,
        };
        return output;
    }
    update(lastInteraction) {
        this.base_update(lastInteraction);
        this.thetaEstimation = this.estimate(); //estimation du niveau de l'élève
        this.updateInfoMatrix(); //mise à jour de la matrice de l'information de Fischer
    }
    isCurriculumFinished() {
        let actId = this.sample();
        this.stopper = new stopping_1.MinSqErrorMaxItemStopper(this._minError, this.nbMaxQuestions, actId);
        return this.isTestFinished();
    }
    // sample_from_history(history: HistoryItem[]): Partial<HierarchyIds> & Partial<ResourceSeriesProperties> {
    //     this.update_history(history); //mise à jour du act_sequence
    //     if (history.length > 0) {
    //         this.thetaEstimation = this.estimate();//estimation du niveau de l'élève
    //         this.updateInfoMatrix();//mise à jour de la matrice de l'information de Fischer
    //     }
    //     let nextItem = this.sample();// sélection de la prochaine question
    //     let actID = get_act_id(this.exercises_ontology, nextItem);
    //     let objID = get_objectiveID_of_activity(actID, this.activities);
    //     this.stopper = new MinSqErrorMaxItemStopper(this._minError, this.nbMaxQuestions, nextItem); //calcul du critère d'arrêt
    //     const isTestFinished = this.isTestFinished(); //Vérifier si le test doit s'arrêter
    //     var exID;
    //     if (isTestFinished) {
    //         exID = this.sampleFromAnywhere();//renvoie une question au hasard juste pour terminer le test
    //         return {
    //             "moduleId": this.main_act,
    //             "objectiveId": objID,
    //             "activityId": get_act_id(this.exercises_ontology, exID),
    //             "exerciseId": exID,
    //             "isModuleFinished": true,
    //             "isAdaptiveTest": true,
    //         };
    //     }
    //     let output = {
    //         "moduleId": this.main_act,
    //         "objectiveId": objID,
    //         "activityId": actID,
    //         "exerciseId": nextItem,
    //         "isModuleFinished": false,
    //         "isAdaptiveTest": true,
    //     };
    //     return output as Partial<HierarchyIds> & Partial<ResourceSeriesProperties>;
    // }
    /**
     * method which selects the next item to be asked in the test
     * @returns next item to ask
     */
    select() { return this.selector.select(this.discriminations_no_anc, this.difficulties, this.thetaEstimation, this.actSequence["act"], this.InformationMatrix); }
    /**
     * method which estimates the theta parameter for the student according to the history of his answers
     * @returns estimation of theta parameter for the student
     */
    estimate() {
        return this.estimator.estimate(this.discriminations_no_anc, this.difficulties, this.actSequence["act"], this.actSequence["res"], tf.tensor(this.thetaEstimation), this.actSequence["weight"]);
    }
    ;
    /**
     * method which samples the first k questions to ask in the test according to a DPP
     * @returns first k questions to ask in the test
     */
    sampleKfirst() {
        const V = (0, matricesGeneration_1.extractRandomInversibleSubmatrix)(this.discriminations_no_anc);
        return (0, initialD_1.kSample)(Array.from(Object.keys(V)), tf.dot(Array.from(Object.values(V)), tf.transpose(Array.from(Object.values(V)))).arraySync(), this.kFirst);
    }
    updateInfoMatrix() {
        var reducedActSequence = [];
        for (let j = 0; j < this.actSequence["act"].length; j++) {
            if (this.actSequence["weight"][j] == 1) {
                reducedActSequence.push(this.actSequence["act"][j]);
            }
        }
        this.InformationMatrix = (0, irt_1.hessian)(this.thetaEstimation, this.discriminations_no_anc, this.difficulties, reducedActSequence);
    }
}
exports.default = CNED_AdaptiveTest;
exports.CNED_AdaptiveTest = CNED_AdaptiveTest;
